import { RefObject, createContext } from 'react';

import { BottomSheetHeight } from '@hh.ru/magritte-ui-bottom-sheet/types';

export interface BottomSheetContextProps {
    contentOverlayRef: RefObject<HTMLDivElement | null>;
    height: BottomSheetHeight;
}

export const BottomSheetContext = createContext<BottomSheetContextProps>({
    contentOverlayRef: { current: null },
    height: 'content',
});
